import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { TableFiltersWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilters } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import Select from "react-select";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import {
  getPackingList,
  setPackingListDate,
  setPackingListType,
} from "../../infrastructure/redux/PackingListSlice";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { z } from "zod";

export const PackingListFilters = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { date, type } = useAppSelector((state) => state.packingList);

  const typeOptions = useMemo(() => {
    const types = [
      "DeliverTake",
      "DeliverCheckForDelivery",
      "DeliverLoadedForDelivery",
      "PickupCheckedForStorage",
      "PickupInStorage",
    ];
    return types.map((type) => ({
      value: type,
      label: t(type),
    }));
  }, []);

  useEffect(() => {
    let stateDate = date;
    let stateType = type;

    const urlDate = searchParams.get("date");
    if (urlDate) {
      dispatch(setPackingListDate(urlDate));
      stateDate = urlDate;
    }

    const urlType = searchParams.get("type");
    if (urlType) {
      dispatch(setPackingListType(urlType));
      stateType = urlType;
    }

    void dispatch(getPackingList({ date: stateDate, type: stateType }));
  }, []);

  const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
    message: "Invalid date format. Expected YYYY-MM-DD.",
  });
  const filterDate = (newDate: string) => {
    if (newDate == date) return;

    const parsed = dateSchema.safeParse(newDate);
    if (!parsed.success) {
      return;
    }

    dispatch(setPackingListDate(newDate));
    void dispatch(getPackingList({ date: newDate, type }));
    searchParams.set("date", newDate);
    setSearchParams(searchParams);
  };

  const filterType = (newType: string) => {
    if (newType == type) return;

    dispatch(setPackingListType(newType));
    void dispatch(getPackingList({ date, type: newType }));
    searchParams.set("type", newType);
    setSearchParams(searchParams);
  };

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={6}>
          <label>{t("Route date")}</label>
          <Form.Control
            type="date"
            placeholder={t("Search by date")}
            value={date}
            onChange={(e) => {
              filterDate(e.target.value);
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("Type")}</label>
          <Select
            noOptionsMessage={() => {
              return t("No options");
            }}
            isMulti={false}
            options={typeOptions}
            value={{
              value: type,
              label: t(type),
            }}
            onChange={(type) => {
              if (type) {
                filterType(type.value);
              }
            }}
            className={"entity-select"}
            classNamePrefix={"entity-select"}
          ></Select>
        </TableFilterInputWrapper>
      </TableFilters>

      {/*{filters?.fields && Object.keys(filters.fields).length > 0 && (*/}
      {/*  <Button*/}
      {/*    onClick={resetFilters}*/}
      {/*    size={"sm"}*/}
      {/*    className="reset-filters"*/}
      {/*    variant="light"*/}
      {/*  >*/}
      {/*    {t("Reset filters")}*/}
      {/*  </Button>*/}
      {/*)}*/}
    </TableFiltersWrapper>
  );
};
